const getNativeInputElement = (el) => el?.querySelector('.q-checkbox,input,textarea,select')

const updateAriaInvalid = (el) => {
  const fieldWrapper = el.closest('.q-field')
  const validatableCheckbox = el.classList.contains('validatable-checkbox') ? el.querySelector('.q-checkbox') : null

  const inputElement = getNativeInputElement(el)

  if (!fieldWrapper && !validatableCheckbox) return

  const hasError = fieldWrapper?.classList.contains('q-field--error') || (el.classList.contains('validatable-checkbox') && validatableCheckbox?.classList.contains('error'))
  if (inputElement) {
    inputElement.setAttribute('aria-invalid', hasError ? 'true' : 'false')
  }
}

const updateAriaRequired = (el, binding) => {
  const inputElement = getNativeInputElement(el)
  if (inputElement && binding.value?.required !== undefined) {
    inputElement.setAttribute('aria-required', binding.value?.required ? 'true' : 'false')
  }
}

export default {
  mounted (el, binding) {
    const observer = new MutationObserver(() => updateAriaInvalid(el))

    const observedElement = el.closest('.q-field') ?? (el.classList.contains('validatable-checkbox') ? el.querySelector('.q-checkbox') : null)

    if (!observedElement) {
      return
    }

    observer.observe(observedElement, {
      attributes: true,
      attributeFilter: ['class']
    })

    updateAriaInvalid(el)
    updateAriaRequired(el, binding)
    el._ariaInvalidObserver = observer
  },
  updated (el, binding) {
    updateAriaRequired(el, binding)
  },
  unmounted (el) {
    if (el._ariaInvalidObserver) {
      el._ariaInvalidObserver.disconnect()
      delete el._ariaInvalidObserver
    }
  }
}
